import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-dropdown-demo',
  templateUrl: './dropdown-demo.component.html',
})
export class NgbDropdownDemoComponent {}
